import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { useStressEntryContext } from "./StressEntryContext";

export const StressLogFileUpload = () => {
  const { dispatch } = useStressEntryContext();

  const saveFiles = (files: File[]) => {
    dispatch({
      type: "SET_SELECTED_FILES",
      payload: { files },
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" color="primary">
          Upload Log Files
        </Typography>

        <DropzoneArea
          filesLimit={
            process.env.REACT_APP_FILE_LIMIT
              ? parseInt(process.env.REACT_APP_FILE_LIMIT)
              : 20
          }
          maxFileSize={12000000}
          onChange={saveFiles}
          // showPreviews={true}
          showPreviewsInDropzone={true}
        />
      </Grid>
    </Grid>
  );
};